jQuery(document).ready(function($){
  // homepage owl carousel
  setTimeout(function(){
    $('#ghiaia-tabbed-products #slider-latest-drops-products, #ghiaia-tabbed-products #slider-best-sellers').owlCarousel({
    loop:false,
    margin:20,
    responsiveClass:true,
    dots:false,
    nav:false,
    responsive:{
        0:{
            items:1.25,
        },
        600:{
            items:3.25,
        },
        1000:{
            items:4.25,
        }
    }
  });
  }, 1500);
  
  

  // homepage tab products
  $('#ghiaia-tabbed-products .tab-header .tab-pill').on('click', function(e){
    e.preventDefault();
    var $this = $(this),
        $tabname = $this.data('tab'),
        $owl = $('.owl-carousel');
    $('#ghiaia-tabbed-products .tab-header .tab-pill, #ghiaia-tabbed-products .tab-content-wrapper .tab-content').removeClass('active');
    $this.addClass('active');
    $('#ghiaia-tabbed-products .tab-content-wrapper #tabbed-products_'+$tabname).addClass('active');
  });
  

  // ghiaia life owl carousel
  $('.ghiaia__carousel-wrapper').owlCarousel({
    loop:true,
    margin:20,
    responsiveClass:true,
    dots:false,
    nav:false,
    center:true,
    responsive:{
        0:{
            items:1.5,
        },
        600:{
            items:2.5,
        },
        1000:{
            items:3.5,
        }
    }
  });
});